export const DEBOUNCE_TIME = 250;

export const SEARCH_TERM_MAP = {
    'DRC': 'Domaine de la Romanee-Conti',
    'BOLLY': 'Bollinger',
};

export function mapTerms(searchString, separator = " ") {
    if (searchString) {
        const searchTerms = searchString.split(separator);
        const mappedSearchTerms = searchTerms.map((term) => {
            if (term && SEARCH_TERM_MAP.hasOwnProperty(term.toUpperCase())) {
                return SEARCH_TERM_MAP[term.toUpperCase()];
            }
            return term;
        });
        return mappedSearchTerms.join(separator);
    }

    return searchString;
}
